<template>
<v-dialog width="500" v-model="createDialog">
  <template slot="activator">
    <Tooltip v-slot:default="{on}" :text="$t('button_descriptions.form.csv_import')">
      <v-btn slot="activator" v-on="on">
        <v-icon small>upload_file</v-icon>
      </v-btn>
    </Tooltip>
  </template>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{$t('archive.add-file') }}
    </v-card-title>

    <v-form v-model="valid" ref="uploadFile">
      <v-card-text>

        <v-text-field :label="`${$t('archive.choose_file')}`" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
        <!-- Hidden -->
        <input type="file" style="display: none" ref="fileInput" accept="*/*" @change="onFilePicked">
        <v-text-field v-model="separator" :label="`${$t('form.upload.separator')}`" required></v-text-field>
        <v-checkbox v-model="skipFirstRow" :label="`${$t('form.upload.skip_first_row')}`" required @change="$v.checkbox.$touch()" @blur="$v.checkbox.$touch()"></v-checkbox>
        <div>

          <div>
            <h4> {{$t('form.upload.match_index')}} </h4>
          </div>

          <div v-for="field in schema.fields" :key="field.id">
            <v-text-field v-if="field.type != 'table'" width="80%" v-model="model[field.order]" :label="field.name" required></v-text-field>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-progress-circular indeterminate color="primary" v-if="loading" spacing="pr-4"></v-progress-circular>
        <v-btn color="primary" :disabled="loading || this.fileObject == null" @click="upload">
          {{ $t('archive.upload') }}
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
import http from '@/plugins/http'
import Tooltip from "../common/Tooltip.vue"

export default {
  components: {Tooltip},
  data() {
    return {
      createDialog: false,
      model: {},
      fileName: '',
      url: '',
      fileObject: null,
      cardResult: '',
      name: '',
      size: '',
      note: '',
      archType: '',
      type: '',
      separator: ";",
      skipFirstRow: false,
      lastModifiedDate: '',
      loading: false,
      valid: false,
      nameRules: [
        (v) => (!v || v.length >= 2) || this.$t('team.create.error.min-length-3'),
        (v) => !!v || this.$t('team.create.error.no-name-msg'),
        (v) => /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(v.charAt(0).toUpperCase()) || this.$t('team.create.error.first-letter-msg'),
      ]
    }
  },
  computed: {
    schema() {
      return this.$store.state.forms.schema
    },
    teams() {
      return this.$store.state.teams
    }
  },
  created() {
    if (this.getCookie('upload_schema') != undefined) {
      this.model = JSON.parse(this.getCookie('upload_schema'))
    }
  },
  methods: {
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
          this.onUploadSelectedFileClick();
        })

      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },
    onUploadSelectedFileClick() {
      this.loading = true
      if (!this.fileObject) {
        alert('No file!!')
      }
      this.name = this.fileObject.name
      this.size = this.fileObject.size
      this.type = this.fileObject.type
      this.lastModifiedDate = this.fileObject.lastModifiedDate

      this.loading = false
    },
    clearForm() {
      this.fileName = ""
      this.fileObject = null
      this.loading = false
    },
    getMap() {
      let fieldsMap = []
      for (let key in this.model) {
        let map = {}
        map.order = key
        map.index = this.model[key]
        fieldsMap.push(map)
      }
      return fieldsMap
    },
    upload() {
      if (this.$refs.uploadFile.validate() && this.fileObject != undefined) {
        this.loading = true

        const json = JSON.stringify(this.getMap());

        let formData = new FormData();
        formData.append('file', this.fileObject);
        formData.append('map', json);
        formData.append('skipFirstRow', this.skipFirstRow);
        formData.append('separator', this.separator);


        http.post('form/' + this.$route.params.schemaId + '/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(() => {
          document.cookie = "upload_schema=" + JSON.stringify(this.model) + "; max-age=31536000; path=/form/" + this.$route.params.schemaId + ";SameSite=Strict";
          this.createDialog = false
          this.clearForm()
          this.$store.commit("setSnack", {
            message: this.$t('base.done').toUpperCase(),
            color: "success",
          })

        }).catch(() => {
          this.loading = false
          this.$store.commit("setSnack", {
            message: this.$t('archive.upload_error'),
            color: "danger",
          })
        })
      }
    },
    getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
  },
}
</script>

<style scoped>
</style>
